module.exports = __webpack_public_path__ + "static/media/baseMeme2thumb.7b5ef704.jpg";